<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <template v-if="!workspaceChannelsDataLoaded">
        <p class="mr-2">Fetching workspace channels.  This can take a few moments for large workspaces.</p>
        <div class="d-flex justify-content-center mb-3">
          <b-spinner label="Fetching workspace channels..."></b-spinner>
        </div>
      </template>
      <template v-else>
        <template v-if="!submittedChannels">
          <h6 class="mb-2">Select channels to analyze.  Best results are acheived when all channels are selected.</h6>
          <multiselect 
          v-model="selectedChannels" 
          :options="workspaceChannelsList" 
          :multiple="true" 
          :close-on-select="false" 
          :clear-on-select="false" 
          :preserve-search="true" 
          :custom-label="channelLabel"
          placeholder="Select channels..."
          selectLabel="Click/Enter to select"
          deselectLabel="Click/Enter to deselect"
          label="name" 
          track-by="slack_id" 
          :preselect-first="false"
          @open="selectorHasFocus = true"
          @close="selectorHasFocus = false">
            <template slot="selection" slot-scope="{ values }">
              <span class="multiselect__single" v-if="values.length > 5">
                {{ values.length }} channels selected
              </span>
            </template>
          </multiselect>

          <div class="mt-3">
            <b-button class="mr-2" href="#" variant="secondary" @click="selectAllClick">Select All</b-button>
            <b-button href="#" variant="danger" @click="clearClick">Clear</b-button>
          </div>

          <b-alert class="mt-3 text-muted" v-if="shouldShowFewChannelsAlert" show fade>Only a small percentage of channels are currently selected.  If this is your intent, carry on!</b-alert>

          <p v-if="selectedChannels.length > 0" class="mt-4">
            Click 'Next' when you are happy with your selection.
          </p>
        </template>
        <template v-else>
          <p>Beginning to monitor channels.  This can take a few moments for large workspaces...</p>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner label="Fetching workspace channels..."></b-spinner>
          </div>
        </template>

      </template>

    </b-card-text>

    <b-button v-if="selectedChannels.length > 0" class="float-right" href="#" variant="primary" @click="nextButtonClick">Next</b-button>
  </div>
</template>


<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'Step2Part2',

  components: { Multiselect },

  data: function() {
    return {
      selectedChannels: [],
      submittedChannels: false,

      selectorHasFocus: false
    }
  },

  watch: {
    
    /*
    // auto select-all when AJAX data loads
    workspaceChannelsList: function(list) {
      this.selectedChannels = list
    }
    */
  },

  computed: {
    workspaceChannelsDataLoaded() {
      return this.$store.state.workspaceChannelsDataLoaded
    },
    workspaceChannelsData() {
      return this.$store.state.workspaceChannelsData
    },
    workspaceChannelsList() {
      return this.$store.state.workspaceChannelsData.data.data
    },

    shouldShowFewChannelsAlert() {
      if(this.workspaceChannelsDataLoaded // data is loaded
        && !this.selectorHasFocus
        && this.workspaceChannelsList.length > 10  // workspace has at least 10 channels
        && this.selectedChannels.length > 0  // at least 1 channel is selected from the dropdown
        && this.selectedChannels.length < this.workspaceChannelsList.length * .25) {
        return true
      }
      return false
    },

    errorResponse() {
      return this.$store.state.errorResponse
    },
    errorMessage() {
      return this.$store.state.errorResponse.data.message
    }
  },

  methods: {
    channelLabel({name}) {
      return '#' + name
    },

    nextButtonClick() {
      this.$store.dispatch('submitWatchedChannels', this.selectedChannels)
      this.submittedChannels = true
      // this.$store.commit('installStep', 3)
      // this.$router.push({ name: 'step3' })
    },

    selectAllClick() {
      this.selectedChannels = this.workspaceChannelsList
    },

    clearClick() {
      this.selectedChannels = []
    },

    channelsSelected(value) {
      this.selectedChannels = value
      // console.log(this.filterGroups)
    },
  },

  mounted() {
    this.$store.commit('installProgress', 50)
    this.$store.dispatch('fetchWorkspaceChannels')
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>